import axios from 'axios'
import cloneDeep from 'lodash/cloneDeep'
import {
  forceLogout,
  hasPersistedSession,
  isSessionInvalidResponse
} from 'utils/authSession'

axios.interceptors.request.use(
  async (config) => {
    const result = cloneDeep(config)
    const token = localStorage.getItem('accessToken')
    // const token = await refreshTokenIfNeeded();
    if (token) {
      result.headers['X-AuthToken'] = token
    }
    return result
  },
  (err) => Promise.reject(err)
)

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (hasPersistedSession() && isSessionInvalidResponse(error)) {
      forceLogout()
    }

    return Promise.reject(error)
  }
)

class AbstractService {
  static get(url, queryParams) {
    return this.request({
      url,
      queryParams
    })
  }

  static post(url, data, queryParams) {
    return this.request({
      method: 'post',
      url,
      data,
      queryParams
    })
  }

  static put({ url, data, queryParams }) {
    return this.request({
      method: 'put',
      url,
      data,
      queryParams
    })
  }

  static del(url, data) {
    return this.request({
      method: 'delete',
      url,
      data
    })
  }

  // destructured request params
  static _get({ subdomain, url, queryParams }) {
    return this.request({
      subdomain,
      url,
      queryParams
    })
  }

  static _post({ subdomain, url, data, queryParams }) {
    return this.request({
      method: 'post',
      subdomain,
      url,
      data,
      queryParams
    })
  }

  static _put({ subdomain, url, data, queryParams }) {
    return this.request({
      method: 'put',
      subdomain,
      url,
      data,
      queryParams
    })
  }

  static _del({ subdomain, url, data }) {
    return this.request({
      method: 'delete',
      subdomain,
      url,
      data
    })
  }

  static request({
    subdomain,
    url,
    method = 'get',
    data,
    queryParams,
    config
  }) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-underscore-dangle
      this._request(
        Object.assign(
          {
            subdomain,
            url,
            method,
            data,
            queryParams
          },
          config
        )
      )
        .then(resolve)
        .catch((error) => reject(error.response))
    })
  }

  // eslint-disable-next-line no-underscore-dangle
  static async _request({
    subdomain,
    url,
    method,
    data,
    queryParams,
    timeout = 25000,
    withCredentials = true,
    headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    auth = {}
  }) {
    const newHeaders = Object.assign({}, headers)

    const baseURL =
      subdomain === null
        ? import.meta.env.VITE_BASE_URL.replace('/playerapi', '') // Remove /playerapi if subdomain is null
        : import.meta.env.VITE_BASE_URL.replace('{0}', subdomain || 'playerapi') // Default to playerapi or other subdomain

    const config = {
      baseURL,
      url,
      method,
      data,
      params: queryParams,
      timeout,
      withCredentials,
      headers: newHeaders,
      auth
    }
    return axios(config)
  }
}

export default AbstractService
